import { StatePage } from "@/components/state-page";
import { isDefinedError } from "@/utils";
import { orpc } from "@/utils/clients/orpc";
import { requirePermissions, useHasPermission } from "@/utils/permissions";
import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { isDefined } from "@workspace/domain/src/utils";
import { t } from "i18next";
import TripForm from "../-form/-index";

export const Route = createFileRoute("/_authenticated/trips/new/")({
  component: RouteComponent,
  beforeLoad: requirePermissions("trip:create"),
  errorComponent: ({ error, reset }) => (
    <StatePage
      error={error}
      reset={reset}
      resourceType="trips.create"
      emptyResourceType={undefined}
    />
  ),
});

function RouteComponent() {
  const navigate = useNavigate();
  const hasTripPermission = useHasPermission("trip:get");

  const createMutation = useMutation(
    orpc.trip.create.mutationOptions({
      onError: async (error) => {
        if (
          isDefinedError(error) &&
          (error.code === "FORBIDDEN" || error.code === "UNAUTHORIZED")
        ) {
          notifications.show({
            title: t("forbidden.title"),
            message: t("trips.create.forbidden.description"),
            color: "red",
          });
          return;
        }

        notifications.show({
          title: error.message || t("unknownError"),
          message: t("trips.create.error.description"),
          color: "red",
        });
      },
    }),
  );

  return (
    <TripForm
      mode="new"
      onSubmit={async ({ payload, images, setImages, form }) => {
        const result = await createMutation.mutateAsync({
          ...payload,
          images: images.map((image) => image.file).filter(isDefined),
        });

        form.reset();
        setImages([]);

        if (hasTripPermission) {
          void navigate({
            to: "/trips/$id",
            params: { id: result.id },
          });
        }

        notifications.show({
          title: t("success"),
          message: t("trips.create.success.description"),
          color: "green",
        });
      }}
    />
  );
}
